import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { WlcmPaginatedData } from '@wlcm/common';
import { DEFAULT_QUERY_PARAMS } from '@wlcm/angular/core';
import { HttpApi } from './http.api';
import { Observable } from 'rxjs';
import { ContentType, ContentTypeQueryParams } from '@core/models/content-type.models';

@Injectable({
  providedIn: 'root',
})
export class ContentTypeService {
  private readonly baseUrl: string = environment.apiUrl;

  constructor(private httpApi: HttpApi) {}

  getPaginated(
    params: ContentTypeQueryParams = DEFAULT_QUERY_PARAMS,
    isOnDemand: boolean = false
  ): Observable<WlcmPaginatedData<ContentType>> {
    const limit = isOnDemand ? '?&view=on-demand' : '';
    return this.httpApi.get<WlcmPaginatedData<ContentType>>(`${this.baseUrl}/content-type${limit}`, { params });
  }
}
